export default __webpack_public_path__ + "static/media/02.704bf9e3.jpg";